import React, { Component } from 'react'
import GeneralBloc from '../../../bloc/general_bloc'
import Labels from '../../constant/labels';
import LanguageBloc from '../../../bloc/language_bloc';
import App_notice_dialog from '../../dialog/app_notice_dialog/app_notice_dialog';
import Config from '../../../Config';

export default class AppViewAction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDialogOpen: false,
            keyword: "",
        };
    }

    stateIsDialogOpen() {
        return this.state.isDialogOpen;
    }

    propDocumentId() {
        return this.props.documentId;
    }

    propStatus() {
        return this.props.status;
    }

    onDialogOpen() {
        this.setState({
            isDialogOpen: true,
        });
    }

    onDialogDismiss() {
        this.setState({
            isDialogOpen: false,
        });
    }

    onCloseDialog(e) {
        if (e == "yes") {
            this.onView();
        } else {
            this.onDialogDismiss();
        }
    }

    onView() {        
        window.location.href = `/${Config.context}/${Config.routes.generic.proposal_view}/${this.propDocumentId()}`;
    }


    render() {
        return (
            <>
                <App_notice_dialog
                    isOpen={this.stateIsDialogOpen()}
                    title={LanguageBloc.getTextByCode(Labels.LBL_DIALOG_VIEW_TITLE)}
                    subTitle={LanguageBloc.getTextByCode(Labels.LBL_DIALOG_VIEW_DESC)}
                    positiveButton={LanguageBloc.getTextByCode(Labels.LBL_DIALOG_VIEW_CONFIRM)}
                    negativeButton={LanguageBloc.getTextByCode(Labels.LBL_DIALOG_VIEW_DECLINE)}
                    onCloseDialog={(e) => {
                        this.onCloseDialog(e);
                    }}
                    showClose={true}
                />
                <img
                    style={{ cursor: "pointer" }}
                    src={
                        GeneralBloc.getAssetsContextPath() +
                        "/assets/icons/HidePasswordIcon.svg"
                    }
                    onClick={(e) => {
                        if (this.propStatus() != "PENDING") {
                            this.onView();
                        }
                        else {
                            this.onDialogOpen();
                        }
                    }}
                    alt={"Eye"}
                    height={24}
                    width={24}
                    className=""
                />
            </>

        )
    }
}
